import {
    GelHeading6,
    GelParagraph
} from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";
import React from "react";

interface InfoAlertProps  {
    title: string;
    body: string;
    style?: React.CSSProperties; // Optional style prop
}

const InfoAlert = (props: InfoAlertProps) => {
    const {title, body, style} = props

    return (
        <div style={{padding: '16px', borderRadius: '4px', border: '1px', background: '#D5F0F0', ...style}}>
            <GelHeading6 style={{fontSize: '15px'}}>{title}</GelHeading6>
            <GelParagraph style={{color: getGelTokens().global.themeColorTextDark }}><div dangerouslySetInnerHTML={{ __html: body }} /></GelParagraph>
        </div>
    );
};

export default InfoAlert;

